(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fetch-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('omaveri-hero-motion')) {
  class OmaveriHeroMotion extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const options = { signal };
      this.video = this.querySelector('video');
      this.image = this.querySelector('.fetch-hero__image');
      this.control = this.querySelector('.fetch-hero__motion-control');
      this.sources = Array.from(this.querySelector('template').content.querySelectorAll('source'));
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.userPaused = false;
      this.failed = false;
      this.manual = false;
      this.visible = false;
      this.ready = false;
      this.video.muted = true;
      this.control.hidden = false;
      this.control.addEventListener('click', () => {
        if (!this.video.paused) {
          this.userPaused = true;
          this.video.pause();
        } else {
          this.manual = true;
          this.userPaused = false;
          this.play();
        }
      }, options);
      this.video.addEventListener('playing', () => {
        this.classList.add('is-playing', 'has-video-frame');
        this.updateControl();
      }, options);
      ['pause', 'ended'].forEach(event => this.video.addEventListener(event, () => {
        this.classList.remove('is-playing');
        this.updateControl();
      }, options));
      this.video.addEventListener('error', () => {
        this.failed = true;
        this.classList.remove('is-playing', 'has-video-frame');
        this.control.hidden = true;
      }, options);
      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches) {
          this.manual = false;
          this.video.pause();
        } else this.maybePlay();
      }, options);
      this.connection?.addEventListener('change', () => {
        if (this.connection.saveData) {
          this.manual = false;
          this.video.pause();
        } else this.maybePlay();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else this.maybePlay();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
        if (this.visible) this.maybePlay();
        else this.video.pause();
      }, { threshold: [0, 0.2] });
      this.observer.observe(this);
      const imageReady = this.image.complete ? Promise.resolve() : new Promise(resolve => {
        this.image.addEventListener('load', resolve, { ...options, once: true });
        this.image.addEventListener('error', resolve, { ...options, once: true });
      });
      const pageReady = document.readyState !== 'loading' ? Promise.resolve() : new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, { ...options, once: true }));
      Promise.all([imageReady, pageReady]).then(async () => {
        try { await this.image.decode(); } catch {}
        if (!this.isConnected || signal.aborted || !this.image.naturalWidth) return;
        this.video.poster = this.image.currentSrc || this.image.src;
        const stylesReady = Promise.all(Array.from(document.querySelectorAll('link[rel="stylesheet"][media="print"]')).filter(link => !link.sheet).map(link => new Promise(resolve => {
          link.addEventListener('load', resolve, { ...options, once: true });
          link.addEventListener('error', resolve, { ...options, once: true });
        })));
        await Promise.race([
          stylesReady.then(() => document.fonts?.ready),
          new Promise(resolve => { this.renderTimer = setTimeout(resolve, 5000); })
        ]);
        clearTimeout(this.renderTimer);
        if (!this.isConnected || signal.aborted) return;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (!this.isConnected || signal.aborted) return;
          const ready = () => { if (signal.aborted) return; this.ready = true; this.maybePlay(); };
          if ('requestIdleCallback' in window) this.idle = requestIdleCallback(ready, { timeout: 1200 });
          else this.timer = setTimeout(ready, 150);
        }));
      });
    }
    maybePlay() {
      if (this.failed || !this.ready || !this.visible || document.hidden || this.userPaused || this.video.ended) return;
      if (!this.manual && (this.dataset.autoplay !== 'true' || this.dataset.designMode === 'true' || this.reducedMotion.matches || this.connection?.saveData || /(^|-)2g$/.test(this.connection?.effectiveType || ''))) return;
      this.play();
    }
    async play() {
      if (this.failed || !this.isConnected) return;
      if (!this.video.getAttribute('src')) {
        const mobile = matchMedia('(max-width: 768px)').matches;
        const device = mobile ? 'mobile' : 'desktop';
        const candidates = this.sources.filter(source => source.dataset.device === device).sort((a, b) => Number(a.dataset.width) - Number(b.dataset.width));
        const source = candidates.find(item => Number(item.dataset.width) >= (mobile ? 720 : 1080)) || candidates.at(-1);
        if (!source) { this.failed = true; this.control.hidden = true; return; }
        this.video.src = source.dataset.src;
        this.video.load();
      }
      if (this.video.ended) this.video.currentTime = 0;
      try {
        await this.video.play();
        if (!this.visible || document.hidden || this.userPaused) this.video.pause();
      } catch { this.updateControl(); }
    }
    updateControl() {
      const paused = this.video.paused;
      this.control.setAttribute('aria-label', this.video.ended ? this.dataset.replayLabel : paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.querySelector('[data-play-icon]').toggleAttribute('hidden', !paused);
      this.querySelector('[data-pause-icon]').toggleAttribute('hidden', paused);
    }
    disconnectedCallback() {
      this.video?.pause();
      this.observer?.disconnect();
      this.abort?.abort();
      if (this.idle && 'cancelIdleCallback' in window) cancelIdleCallback(this.idle);
      clearTimeout(this.timer);
      clearTimeout(this.renderTimer);
      this.abort = null;
    }
  }
  customElements.define('omaveri-hero-motion', OmaveriHeroMotion);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.scheduleHeaderHeightMeasurement = this.scheduleHeaderHeightMeasurement.bind(this);
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.observeHeaderHeight();

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    observeHeaderHeight() {
      if (typeof ResizeObserver === 'function') {
        this.headerResizeObserver = new ResizeObserver((entries, observer) => {
          if (!this.isConnected || observer !== this.headerResizeObserver) return;
          const entry = entries.find((item) => item.target === this.header);
          if (!entry) return;
          const box = entry.borderBoxSize?.[0] || entry.borderBoxSize;
          if (Number.isFinite(box?.blockSize)) {
            this.setHeaderHeight(box.blockSize);
          } else {
            this.scheduleHeaderHeightMeasurement();
          }
        });
        try {
          this.headerResizeObserver.observe(this.header, { box: 'border-box' });
        } catch {
          this.headerResizeObserver.observe(this.header);
        }
      } else {
        window.addEventListener('resize', this.scheduleHeaderHeightMeasurement);
        document.fonts?.addEventListener('loadingdone', this.scheduleHeaderHeightMeasurement);
        this.header.addEventListener('load', this.scheduleHeaderHeightMeasurement, true);
        this.scheduleHeaderHeightMeasurement();
      }
    }

    setHeaderHeight(height) {
      if (!Number.isFinite(height) || height < 0) return;
      const value = `${Math.round(height)}px`;
      if (document.documentElement.style.getPropertyValue('--header-height') !== value) {
        document.documentElement.style.setProperty('--header-height', value);
      }
    }

    scheduleHeaderHeightMeasurement() {
      if (this.headerHeightFrame !== undefined || !this.isConnected) return;
      this.headerHeightFrame = requestAnimationFrame(() => {
        this.headerHeightFrame = requestAnimationFrame(() => {
          this.headerHeightFrame = undefined;
          if (this.isConnected) this.setHeaderHeight(this.header.offsetHeight);
        });
      });
    }

    disconnectedCallback() {
      this.headerResizeObserver?.disconnect();
      this.headerResizeObserver = null;
      this.headerBoundsObserver?.disconnect();
      this.headerBoundsObserver = null;
      cancelAnimationFrame(this.headerHeightFrame);
      this.headerHeightFrame = undefined;
      cancelAnimationFrame(this.headerScrollFrame);
      this.headerScrollFrame = undefined;
      window.clearTimeout(this.isScrolling);
      window.removeEventListener('resize', this.scheduleHeaderHeightMeasurement);
      document.fonts?.removeEventListener('loadingdone', this.scheduleHeaderHeightMeasurement);
      this.header?.removeEventListener('load', this.scheduleHeaderHeightMeasurement, true);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      this.headerBoundsObserver = new IntersectionObserver((entries, observer) => {
        if (!this.isConnected || observer !== this.headerBoundsObserver) return;
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      this.headerBoundsObserver.observe(this.header);
    }

    scheduleHeaderScrollUpdate(update) {
      cancelAnimationFrame(this.headerScrollFrame);
      this.headerScrollFrame = requestAnimationFrame(() => {
        this.headerScrollFrame = undefined;
        if (this.isConnected) update.call(this);
      });
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        this.scheduleHeaderScrollUpdate(this.hide);
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.scheduleHeaderScrollUpdate(this.reveal);
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.scheduleHeaderScrollUpdate(this.hide);
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.scheduleHeaderScrollUpdate(this.reset);
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
